import { TODAY } from '../../constants';
import { isoStr } from '../../utils/dates';
import { resolveUpdate } from './resolve';

export const createTimesheetsSlice = (set) => ({
  timesheetManagerDevId: 'all',
  setTimesheetManagerDevId: (suivant) =>
    set((etat) => ({ timesheetManagerDevId: resolveUpdate(suivant, etat.timesheetManagerDevId) })),
  timesheetMonth: (() => isoStr(TODAY).slice(0, 7))(),
  setTimesheetMonth: (suivant) =>
    set((etat) => ({ timesheetMonth: resolveUpdate(suivant, etat.timesheetMonth) })),
  timesheetMonthData: {},
  setTimesheetMonthData: (suivant) =>
    set((etat) => ({ timesheetMonthData: resolveUpdate(suivant, etat.timesheetMonthData) })),
  timesheetDay: null,
  setTimesheetDay: (suivant) =>
    set((etat) => ({ timesheetDay: resolveUpdate(suivant, etat.timesheetDay) })),
  timesheetDayDraft: [],
  setTimesheetDayDraft: (suivant) =>
    set((etat) => ({ timesheetDayDraft: resolveUpdate(suivant, etat.timesheetDayDraft) })),
  timesheetDayJira: null, // null | { loading:true } | { entries:[{issueKey,summary,hours}], error? }
  setTimesheetDayJira: (suivant) =>
    set((etat) => ({ timesheetDayJira: resolveUpdate(suivant, etat.timesheetDayJira) })),
  timesheetDayHover: null, // { dateStr, rect, entries }
  setTimesheetDayHover: (suivant) =>
    set((etat) => ({ timesheetDayHover: resolveUpdate(suivant, etat.timesheetDayHover) })),
  timesheetUserId: 'me', // collaborateur affiché/exporté (manager)
  setTimesheetUserId: (suivant) =>
    set((etat) => ({ timesheetUserId: resolveUpdate(suivant, etat.timesheetUserId) })),
  exporting: false,
  setExporting: (suivant) => set((etat) => ({ exporting: resolveUpdate(suivant, etat.exporting) })),
});
